
/**
 * Simplybook intregation
 * 
 * There is multiple modes for time picker. 
 * Main modes are:  
 *  - default - first aivable time (fixed service, any practitioner)
 *    "Find first time available"
 *  - RepeatVisit - Predefined service and practitioner?
 *    "Visit the same doctor"
 *  - allDoctor -Fixed service, choose practitioner
 *    "Choose doctor"
 * 
 * activeMode - is the mode that is currently selected to pick a time (default, repeatVisit, allDoctors)
 * 
 * 
 */

import React from "react";
import { Trans } from "react-i18next";
import i18n from "./../../Documental/Localization/i18n.js";
 
 
class TimePicker extends React.Component {

    constructor(props) {
        super(props);

        let patients = window.appEntityStore.getAllResourcesBySearchParams({
            "resourceType" : "Patient"
        });
        
        let pseudoName = '';
        let email = '';
        let phone = '';

        // there should be only 1 patient resource
        for( var ii in patients ){
            // pseudoName = patients[ ii ].getFullName();
            pseudoName = patients[ ii ].getAnonymousName();
            
            let phoneObj = patients[ ii ].getFirstTelecomBySystemCode( "phone" );
            if( phoneObj !== null ){
                phone = patients[ ii ].getFirstTelecomBySystemCode( "phone" ).getValue();
            }

            let emailObj = patients[ ii ].getFirstTelecomBySystemCode( "email" );
            if( emailObj !== null ){
                email = patients[ ii ].getFirstTelecomBySystemCode( "email" ).getValue();
            }
        }
        
        this.state = {
            "pseudoName" : pseudoName,
            "email" : "no-reply@documental.ee",
            "phone" : '',

            "calendarApiEndpointPolling" : true, // When we wait / poll Endpoint resource to arrive
        }
        
        this.timerDataSyncedPoll = null;
        this.timerBookingOnSimpleBookFinishedPoll = null;
        this.timerBookingFinishedPoll = null;
        
        
        this.handleSkipBooking = this.handleSkipBooking.bind( this );
    }

 
    componentDidMount() {
        // wait until Endpoint resource is recieved from server- so we can initalize Scheduler jquery component
        // and add "api_token"
        window.appBookingFinished = false;
        window.appBookingsCreated = [];
        
        window.repeatVisitTimepickerVisited = true;

        this.pollDataSyncDone();
        this.pollBookingOnSimpleBookFinished();
    }


    componentWillUnmount() {
        if( this.timerDataSyncedPoll !== null ){
            clearTimeout( this.timerDataSyncedPoll );
            this.timerDataSyncedPoll = null;
        }
        if( this.timerBookingOnSimpleBookFinishedPoll !== null ){
            clearTimeout( this.timerBookingOnSimpleBookFinishedPoll );
            this.timerBookingOnSimpleBookFinishedPoll = null;
        }
        if( this.timerBookingFinishedPoll !== null ){
            clearTimeout( this.timerBookingFinishedPoll );
            this.timerBookingFinishedPoll = null;
        }
    }
   

    pollDataSyncDone = () => {
        var that = this;
        
        console.log("pollDataSyncDone");
        console.log(window.mainResult);

        if ( this.timerDataSyncedPoll != null) {
            clearTimeout( this.timerDataSyncedPoll );
        }
        
        //let testPatientResource = window.appEntityStore.getEntityByEntityId( this.patientIdSyncing );
        //let syncing = window.appEntityStore.isRecourceSyncing( testPatientResource );

        let syncing = true;

        var endpoints = window.appEntityStore.getAllResourcesBySearchParams({
            "resourceType" : "Endpoint"
        });
        
        let extractedToken = '';
        let extractedLogin = '';

        if( endpoints && endpoints.length > 0 && typeof window.Scheduler !== "undefined" ){
            let res = endpoints[ 0 ].toObject();
            console.log( res );
            syncing = false;
            
            for( var i in res.header ){
                if( res.header[ i ].indexOf( "X-User-Token" ) > -1 ){
                    extractedToken = res.header[ i ];
                    extractedToken = extractedToken.split( "'X-User-Token':'" ).join( "" );
                    extractedToken = extractedToken.split( "X-User-Token:" ).join( "" );
                    extractedToken = extractedToken.split( "X-User-Token" ).join( "" );
                    extractedToken = extractedToken.split( "'" ).join( "" );
                    extractedToken = extractedToken.split( ":" ).join( "" ).trim();
                    //extractedToken = extractedToken.slice(0, -1);
                }
                if( res.header[ i ].indexOf( "X-Company-Login" ) > -1 ){
                    extractedLogin = res.header[ i ];
                    extractedLogin = extractedLogin.split( "'X-Company-Login':'" ).join( "" );
                    extractedLogin = extractedLogin.split( "X-Company-Login:" ).join( "" );
                    extractedLogin = extractedLogin.split( "X-Company-Login" ).join( "" );
                    extractedLogin = extractedLogin.split( "'" ).join( "" );
                    extractedLogin = extractedLogin.split( ":" ).join( "" ).trim();
                }
            }
        }
        
        if( syncing ){
            this.timerDataSyncedPoll = setTimeout(function () {
                that.pollDataSyncDone();
            }, 250 );
            return;
        }

        this.patientSynced = true;

        this.setState({
            "calendarApiEndpointPolling" : false
        });

        /*
        if( typeof window.mainResult !== 'undefined' && typeof window.mainResult.finalServiceProvider !== 'undefined' ){
            if( window.mainResult.finalServiceProvider === "psychiatrist" ){
            formTitle = "Book a video-consultation with a psychiatrist";
            }
            if( window.mainResult.finalServiceProvider === "psychologist" ){
            formTitle = "Book a video-consultation with a psychologist";
            }
        }

        let hcServices = window.appEntityStore.getAllResourcesBySearchParams({
            "resourceType" : "HealthcareService"
        });

        let hcServicesList = [];
        for( var i6 in hcServices ){
            hcServicesList.push( hcServices[ i6 ].toObject() );
        }
        */
       
        
        let initialEventId = window.mainResult.bookingServiceId;
        let initialUnitId  = -1; // round robin if -1

        if( window.mainResult.activeMode === "default" ){
            initialEventId = window.mainResult.bookingServiceId;
        }

        if( window.mainResult.activeMode === "repeatVisit" ){
            initialEventId = window.mainResult.repeatVisitBookingServiceId;
            initialUnitId = window.mainResult.repeatVisitBookingPracticionerId;
        }

        if( window.mainResult.activeMode === "allDoctors" ){
            initialEventId = window.mainResult.allDoctorsBookingServiceId;
            initialEventId = -2; // Select first unit
        }
       
        // there is 3 modes in total

        try {
            let months = {
                "January" : i18n.t("January"),
                "February" : i18n.t("February"),
                "March" : i18n.t("March"),
                "April" : i18n.t("April"),
                "May" : i18n.t("May"),
                "June" : i18n.t("June"),
                "July" : i18n.t("July"),
                "August" : i18n.t("August"),
                "September" : i18n.t("September"),
                "October" : i18n.t("October"),
                "November" : i18n.t("November"),
                "December" : i18n.t("December"),
            };
            new window.Scheduler( {
                "api_token" : extractedToken,
                "api_login" : extractedLogin,
                "api_url" : "//user-api.simplybook.me",
                "ui_language" : i18n.language,
                "monthTranslations" : months,
                "anyEmployeeText" : i18n.t("All doctors"),
                "date_format" : "yyyy-mm-dd",

                // timepicker working mode and aivalable modes
                "activeMode" : window.mainResult.activeMode,
                "showModeDefault" : window.mainResult.showModeDefault,
                "showModeAllDoctors" : window.mainResult.showModeAllDoctors,
                "showModeRepeatVisit" : window.mainResult.showModeRepeatVisit,
                "bookModeRepeatVisit2" : window.mainResult.showModeRepeatVisit,// use same as showModeRepeatVisit

                // values for initial load for event_id and unit_id
                "initialEventId" : initialEventId,
                "initialUnitId" : initialUnitId,
                
                // Data nbeeded for diffrent picker modes, and their initial values when re-choosing that mode
                // 1) default
                "modeDefaultInitialEventId"  : window.mainResult.bookingServiceId, 


                // 2) allDoctors 
                "modeAllDoctorsInitialEventId" : window.mainResult.allDoctorsBookingServiceId, // simplybook id for service

                // 3) repeatVisit
                "modeRepeatVisitInitialEventId" : window.mainResult.repeatVisitBookingServiceId, // simplybook id for service
                "modeRepeatVisitInitialUnitId" : window.mainResult.repeatVisitBookingPracticionerId, // simplybook id for unit
                "repeatVisitServicesProposed" : window.mainResult.repeatVisitServicesProposed,
                /* repeatVisitServicesProposed is Array of objects like this
                    {
                        "simplybookServiceId": 1,
                        "name": "Psychiatrist"
                    } 
                */
                
                // can mode selection be even shown? If only default aivable, no need to show
                "chooseServiceManually" : (window.mainResult.showModeAllDoctors || window.mainResult.showModeRepeatVisit)
                
                //"healthcareServices" : hcServicesList
            } );
        } catch (error) {
            console.error(error);
            if( typeof window.appLogger !== "undefined" ){
                window.appLogger.logErrorObject( error, "Error from pollDataSyncDone method in TimePicker", {
                    "window.mainResult" : window.mainResult
                } );
            }
        }
        
    }


    /**
     * Booking is done on seperately from react (used jQuery plugin)
     * If that finishes a (global) flag will be set to let react know we can move on 
     * 
     * Before moving on - we have to save some data along ServiceRequest
     */
     pollBookingOnSimpleBookFinished(){
        var that = this;
        
        if( this.timerBookingOnSimpleBookFinishedPoll !== null ){
            clearTimeout( this.timerBookingOnSimpleBookFinishedPoll );
            this.timerBookingOnSimpleBookFinishedPoll = null;
        }

        if( typeof window.appBookingFinished === "undefined" || window.appBookingFinished === false ){
            this.timerBookingOnSimpleBookFinishedPoll = setTimeout(function () {
                that.pollBookingOnSimpleBookFinished();
            }, 250 );
            return;
        }

        let serviceRequest = window.appEntityStore.getResourceById( window.mainResult.serviceRequestId );
        serviceRequest.setStatus( "completed" );
        serviceRequest._resourceLiteral.intent = "order";
        
        if( typeof serviceRequest._resourceLiteral.identifier === "undefined" ){
            serviceRequest._resourceLiteral.identifier = [];
        }

        let booking = null;

        // there should be only one booking created by simplbook.me API
        for( var i in window.appBookingsCreated ){
            booking = window.appBookingsCreated[ i ];
        }

        if( booking !== null ){
            /* 
            Data from booking: 
                client_hash: "da25c43e744bcbaa8c1838ae62a3a130"
                client_id: "37"
                code: "2a6cz7fz"
                end_date_time: "2022-05-24 13:30:00"
                event_id: 1
                hash: "6c7f408be010f2705d370f095e1be1b6"
                id: "36"
                is_confirmed: "1"
                require_payment: false
                start_date_time: "2022-05-24 13:00:00"
                time_offset: "0"
                unit_id: 2
            */
            serviceRequest._resourceLiteral.identifier.push( {
                "system" : "http://documental.ee/fhir/naming/simplybook/booking/id",
                "value" : booking.id
            } );
            serviceRequest._resourceLiteral.identifier.push( {
                "system" : "http://documental.ee/fhir/naming/simplybook/booking/hash",
                "value" : booking.hash
            } );
            serviceRequest._resourceLiteral.identifier.push( {
                "system" : "http://documental.ee/fhir/naming/simplybook/booking/code",
                "value" : booking.code
            } );

            /*
                "occurrencePeriod": {
                    "start": "2022-04-26T11:48:35+03:00",
                    "end": "2022-04-26T11:48:35+03:00"
                },
            */
        }

        window.appEntityStore.saveResource( serviceRequest );

        this.pollBookingFinished();
    }
    
    
    /**
     * Before moving on - we have to save some data along ServiceRequest
     */
    pollBookingFinished(){
        var that = this;
        
        if( this.timerBookingFinishedPoll !== null ){
            clearTimeout( this.timerBookingFinishedPoll );
            this.timerBookingFinishedPoll = null;
        }
        
        let testResource = window.appEntityStore.getEntityByEntityId( window.mainResult.serviceRequestId );
        let syncing = window.appEntityStore.isRecourceSyncing( testResource );

        if( syncing ){
            this.timerBookingFinishedPoll = setTimeout(function () {
                that.pollBookingFinished();
            }, 50 );
            return;
        }

        console.log( "Service request final synced" );
        console.log( testResource.toObject() );

        if( typeof this.props.onBookingDone !== "undefined" ){
            this.props.onBookingDone( );
        }
    }


    handleSkipBooking( ){
      if( typeof this.props.onSkipBooking ){
        this.props.onSkipBooking();
      }
      return false;
    }


   render() {

    let performerClasses = "dl-horizontal service-provider-booked";
    
    // Show or hide unit_id and event_id field initially based on selected mode, Service is always hidden in current modes
    let classChooseServiceManually = "form-group manual-service-selector-wrap form-field";

    let classChoosePracticionerManually = "form-group manual-practicioner-selector-wrap form-field";
    if( window.mainResult.activeMode !== "alldoctors" ){
        classChoosePracticionerManually += ' hidden';
    }
    
    if( window.mainResult.activeMode !== "repeatVisit2" ){
        classChooseServiceManually += ' hidden';
    }
    
    // get classes for mode selection buttons
    // previously btn-manual-fixed-toggle   btn-manual-fixed-toggle-fixed  btn-manual-fixed-toggle-manual
     let classesBtnModeDefault       = 'btn-inline-answer btn-timepicker-mode  btn-timepicker-mode-modeDefault';
     let classesBtnModeAllDoctors    = 'btn-inline-answer btn-timepicker-mode  btn-timepicker-mode-modeAllDoctors';
     let classesRepeatVisit          = 'btn-inline-answer btn-timepicker-mode  btn-timepicker-mode-modeRepeatVisit';
     let classesRepeatVisit2         = 'btn-inline-answer btn-timepicker-mode  btn-timepicker-mode-modeRepeatVisit2';

     if( window.mainResult.activeMode === "default" ){
        classesBtnModeDefault += ' selected';
        performerClasses += ' hidden';
     }
     if( window.mainResult.activeMode === "alldoctors" ){
        classesBtnModeAllDoctors += ' selected';
     }
     if( window.mainResult.activeMode === "repeatVisit" ){
        classesRepeatVisit += ' selected';
     }
     if( window.mainResult.activeMode === "repeatVisit2" ){
        classesRepeatVisit2 += ' selected';
     }

     // Get mode names for mode buttons. Overwrite with fixed translations
     let modeDefaultName = window.mainResult.bookingServiceName;
     modeDefaultName = i18n.t( 'bookModeDefault' );
     
     let modeAllDoctorsName = window.mainResult.allDoctorsBookingServiceName;
     modeAllDoctorsName = i18n.t( 'bookModeAllDoctors' );
     
     let modeRepeatVisitName = i18n.t( 'bookModeRepeatVisit' );
     
     let modeRepeatVisitName2 = i18n.t( 'bookModeRepeatVisit2' );

     return (

        <div className="">
          <div className="form">
              <div className="col-sm-12">
                  <form className="form-horizontal text-dark">
                      <div id="schedule">
                        
                        <div className="form-group manual-practicioner-selector-toggle-wrap form-field hidden">
                            { ( window.mainResult.showModeDefault ) && (
                                <a href="#" 
                                    className={classesBtnModeDefault}  
                                    data-mode-id="modeDefault" 
                                ><span className="">{modeDefaultName}</span></a>
                            )}
                            
                            { ( window.mainResult.showModeAllDoctors ) && (
                                <a href="#" 
                                    className={classesBtnModeAllDoctors} 
                                    data-mode-id="modeAllDoctors"
                                ><span className="">{modeAllDoctorsName}</span></a>
                            )}
                            
                            { ( window.mainResult.showModeRepeatVisit ) && (
                                <a href="#" 
                                    className={classesRepeatVisit} 
                                    data-mode-id="modeRepeatVisit"
                                ><span className="">{modeRepeatVisitName}</span></a>
                            )}

                            { ( window.mainResult.showModeRepeatVisit ) && (
                                <a href="#" 
                                    className={classesRepeatVisit2} 
                                    data-mode-id="modeRepeatVisit2"
                                ><span className="">{modeRepeatVisitName2}</span></a>
                            )}

                        </div>

                        <div>
                            <div className={classChooseServiceManually}>
                                <label htmlFor="event_id" className="control-label"><Trans>Select service</Trans></label>
                                <select id="event_id" className="form-control input time-handler">
                                </select>
                            </div>

                            <div className={classChoosePracticionerManually}>
                                <label htmlFor="unit_id" className="control-label"><Trans>Select practicioner</Trans></label>
                                <select id="unit_id" className="form-control input time-handler">
                                </select>
                            </div>
                        </div>

                        <div className="form-group form-field">
                            <div className="row">
                                <div className="col-sm-3 mb-2">
                                    <div id="date"></div>
                              </div>
                              <div className="col-sm-4 mb-4">
                                    <label htmlFor="unit_id" id="calendar-pick-time-label" title="v.132" className="control-label hidden">
                                        <Trans>Select time for 30 minutes consultation</Trans>
                                    </label>
                                    
                                    {( this.state.calendarApiEndpointPolling ) && (
                                            <div className="col-sm-12" id="calendar-endpoint-loading"><Trans>The calendar is loading</Trans></div>
                                    )}
                                    {( !this.state.calendarApiEndpointPolling ) && (
                                        <div className="col-sm-12" id="calendar-plugin-loading"><Trans>The calendar is loading</Trans> ...</div>
                                    )}
                                    
                                    <div className="col-sm-12 hidden" id="calendar-pick-date-to-see-times"><Trans>Pick a date to see available times</Trans> ...</div>
                                    <div className="col-sm-12 hidden" id="calendar-loading-times"><Trans>Loading available times</Trans> ...</div>
                                    <div className="col-sm-12 hidden" id="calendar-loading-dates"><Trans>Loading available dates</Trans> ...</div>
                                    <div className="col-sm-12 hidden" id="calendar-no-available-times"><Trans>No available times</Trans></div>
                                    <div className="col-sm-12 hidden" id="calendar-no-available-dates"><Trans>No available dates found</Trans></div>
                                    <div className="col-sm-12 hidden" id="calendar-no-available-dates-current-month"><Trans>No available dates were found in the selected month</Trans></div>
                                    
                                    <div id="time" className="row mt-4">
                                        
                                    </div>
                              </div>
                            </div>
                        </div>

                        <div className="form-group form-field hidden" id="qty-element">
                              <label htmlFor="qty" className="control-label">Select bookings quantity</label>
                              <select name="qty" id="qty" className="form-control time-handler">
                                  <option value="1">1</option>
                              </select>
                        </div>
                        <div className="form-group form-field">
                            <button 
                                type="button" 
                                className="btn btn-lg btn-default full-width dark disabled" 
                                onClick={this.handleSkipBooking}
                                id="iquit"><Trans>I don't want to proceed</Trans></button>
                            <button type="button" className="btn btn-lg btn-default full-width dark hidden" id="book"><Trans>Confirm time</Trans></button>
                        </div>
                      </div>

                      <div id="client" className="hidden text-leading-8">
                          <div>
                            <dl className="dl-horizontal">
                                <dt><Trans>Service</Trans></dt>
                                <dd id="event_name"></dd>
                            </dl>
                            <dl className={performerClasses}>
                                <dt><Trans>Service performer</Trans></dt>
                                <dd id="unit_name"></dd>
                            </dl>
                            <dl className="dl-horizontal">
                                <dt><Trans>Selected date</Trans></dt>
                                <dd>
                                    <span id="date_start_date" className=""></span>
                                    <span id="date_start" className="hidden"></span>
                                </dd>
                            </dl>
                            <dl className="dl-horizontal">
                                <dt><Trans>Selected time</Trans></dt>
                                <dd>
                                    <span id="date_start_time" className=""></span>
                                </dd>
                            </dl>
                          </div>
                          
                          <div className="hidden">
                            <div className="form-group form-field">
                                <label htmlFor="name" className="col-sm-2 control-label"><Trans>Name</Trans></label>
                                <div className="col-sm-10">
                                    <input type="name" className="form-control" id="name" placeholder="Client name" defaultValue={this.state.pseudoName} />
                                </div>
                            </div>
                            <div className="form-group form-field">
                                <label htmlFor="email" className="col-sm-2 control-label"><Trans>E-mail</Trans></label>
                                <div className="col-sm-10">
                                    <input type="email" className="form-control" id="email" placeholder="Email" defaultValue={this.state.email} />
                                </div>
                            </div>
                            <div className="form-group form-field">
                                <label htmlFor="phone" className="col-sm-2 control-label"><Trans>Phone</Trans></label>
                                <div className="col-sm-10">
                                    <input type="phone" className="form-control" id="phone" placeholder="Phone" defaultValue={this.state.phone} />
                                </div>
                            </div>
                            <div id="additional-fields">
                            </div>
                          </div>  
                        
                          <div className="form-group form-field">
                              <button type="button" className="btn btn-navigate-back mr-6" id="cancel"><Trans></Trans></button>
                              <button type="button" className="btn btn-lg btn-primary ml-4 dark" id="add_booking">Add more bookings</button>
                              <button type="button" className="btn btn-lg btn-primary dark" id="confirm_batch">Confirm</button>
                              <button type="button" className="btn btn-lg btn-primary dark" id="confirm"><Trans>Confirm booking</Trans></button>
                          </div>
                      </div>

                  </form>
              </div>
          </div>
      </div>
     );
   }
 

   renderTest() {
    return (<div className="form">
        <div className="col-sm-12">
        <form role="form" className="form-horizontal text-white">
            <div id="schedule">
                <div className="hiddenx">
                    <div className="form-group form-field">
                    <label htmlFor="event_id" className="control-label">Select service</label>
                    <select id="event_id" className="form-control time-handler">
                        <option value="1">Teenus 1</option>
                        <option value="2">Teenus 2</option>
                        <option value="1">Psühholoogiline nõustamine</option>
                        <option value="2">Psühhiaatriline nõustamine</option>
                    </select>
                    </div>
                    <div className="form-group form-field">
                    <label htmlFor="unit_id" className="control-label">Select service performer</label>
                    <select id="unit_id" className="form-control time-handler">
                        <option></option>
                        <option value="-1">Any employee</option>
                        <option value="1">Dr Mänd</option>
                        <option value="2">Dr Kask</option>
                        <option value="3">Dr Lepp</option>
                        <option value="4">Dr Kuusk</option>
                        <option value="5">Dr Tamm</option>
                    </select>
                    </div>
                </div>
                <div className="form-group form-field">
                    <div className="row">
                    <div className="col-sm-3">
                        <label htmlFor="date" className="control-label hidden">Select date start</label>
                        <div id="date">
                            <div className="datepicker">
                                <div className="datepicker-days" >
                                <table className=" table-condensed">
                                    <thead>
                                        <tr>
                                            <th className="prev" >«</th>
                                            <th colSpan="5" className="datepicker-switch">May 2022</th>
                                            <th className="next" >»</th>
                                        </tr>
                                        <tr>
                                            <th className="dow">Su</th>
                                            <th className="dow">Mo</th>
                                            <th className="dow">Tu</th>
                                            <th className="dow">We</th>
                                            <th className="dow">Th</th>
                                            <th className="dow">Fr</th>
                                            <th className="dow">Sa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="old disabled day">24</td>
                                            <td className="old disabled day">25</td>
                                            <td className="old disabled day">26</td>
                                            <td className="old disabled day">27</td>
                                            <td className="old disabled day">28</td>
                                            <td className="old disabled day">29</td>
                                            <td className="old disabled day">30</td>
                                        </tr>
                                        <tr>
                                            <td className="today day disabled">1</td>
                                            <td className="day">2</td>
                                            <td className="day">3</td>
                                            <td className="day">4</td>
                                            <td className="day">5</td>
                                            <td className="day">6</td>
                                            <td className="day disabled">7</td>
                                        </tr>
                                        <tr>
                                            <td className="day disabled">8</td>
                                            <td className="day">9</td>
                                            <td className="day">10</td>
                                            <td className="day">11</td>
                                            <td className="day">12</td>
                                            <td className="day">13</td>
                                            <td className="day disabled">14</td>
                                        </tr>
                                        <tr>
                                            <td className="day disabled">15</td>
                                            <td className="day">16</td>
                                            <td className="day">17</td>
                                            <td className="active day">18</td>
                                            <td className="day">19</td>
                                            <td className="day">20</td>
                                            <td className="day disabled">21</td>
                                        </tr>
                                        <tr>
                                            <td className="day disabled">22</td>
                                            <td className="day">23</td>
                                            <td className="day">24</td>
                                            <td className="day">25</td>
                                            <td className="day">26</td>
                                            <td className="day">27</td>
                                            <td className="day disabled">28</td>
                                        </tr>
                                        <tr>
                                            <td className="day disabled">29</td>
                                            <td className="day">30</td>
                                            <td className="day">31</td>
                                            <td className="new day">1</td>
                                            <td className="new day">2</td>
                                            <td className="new day">3</td>
                                            <td className="new day">4</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="7" className="today">Today</th>
                                        </tr>
                                        <tr>
                                            <th colSpan="7" className="clear">Clear</th>
                                        </tr>
                                    </tfoot>
                                </table>
                                </div>
                                <div className="datepicker-months">
                                <table className="table-condensed">
                                    <thead>
                                        <tr>
                                            <th className="prev" >«</th>
                                            <th colSpan="5" className="datepicker-switch">2022</th>
                                            <th className="next" >»</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan="7"><span className="month disabled">Jan</span><span className="month disabled">Feb</span><span className="month disabled">Mar</span><span className="month disabled">Apr</span><span className="month active">May</span><span className="month">Jun</span><span className="month">Jul</span><span className="month">Aug</span><span className="month">Sep</span><span className="month">Oct</span><span className="month">Nov</span><span className="month">Dec</span></td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="7" className="today">Today</th>
                                        </tr>
                                        <tr>
                                            <th colSpan="7" className="clear">Clear</th>
                                        </tr>
                                    </tfoot>
                                </table>
                                </div>
                                <div className="datepicker-years" >
                                <table className="table-condensed">
                                    <thead>
                                        <tr>
                                            <th className="prev">«</th>
                                            <th colSpan="5" className="datepicker-switch">2020-2029</th>
                                            <th className="next">»</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan="7"><span className="year old disabled">2019</span><span className="year disabled">2020</span><span className="year disabled">2021</span><span className="year active">2022</span><span className="year">2023</span><span className="year">2024</span><span className="year">2025</span><span className="year">2026</span><span className="year">2027</span><span className="year">2028</span><span className="year">2029</span><span className="year new">2030</span></td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="7" className="today">Today</th>
                                        </tr>
                                        <tr>
                                            <th colSpan="7" className="clear">Clear</th>
                                        </tr>
                                    </tfoot>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 timepicker-times">
                        <label htmlFor="unit_id" className="control-label">Select time start 1</label>
                        <div id="time" className="row">
                            <div className="col-sm-12" id="busy">All slots are busy.</div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="hidden" id="qty-element">
                    <label htmlFor="qty" className="control-label">Select bookings quantity</label>
                    <select name="qty" id="qty" className="form-control time-handler">
                        <option value="1">1</option>
                    </select>
                </div>
                <div className="form-group form-field"><button type="button" className="btn btn-lg btn-default full-width dark" id="book">Book</button></div>
            </div>


            <div id="client">
                <div>
                    <dl className="dl-horizontal">
                    <dt>Service</dt>
                    <dd id="event_name"></dd>
                    </dl>
                    <dl className="dl-horizontal hidden">
                        <dt>Service performer</dt>
                        <dd id="unit_name"></dd>
                    </dl>
                    <dl className="dl-horizontal">
                    <dt>Selected date and time</dt>
                    <dd><span id="date_start"></span> - <span id="date_end"></span></dd>
                    </dl>
                </div>

                <div className="hidden">
                    <div className="form-group form-field">
                    <label htmlFor="name" className="col-sm-2 control-label">Client name</label>
                    <div className="col-sm-10"><input type="name" className="form-control" id="name" placeholder="Client name" defaultValue="sson" /></div>
                    </div>
                    <div className="form-group form-field">
                    <label htmlFor="email" className="col-sm-2 control-label">Email</label>
                    <div className="col-sm-10"><input type="email" className="form-control" id="email" placeholder="Email" defaultValue="xcom" /></div>
                    </div>
                    <div className="form-group form-field">
                    <label htmlFor="phone" className="col-sm-2 control-label">Phone</label>
                    <div className="col-sm-10"><input type="phone" className="form-control" id="phone" placeholder="Phone" defaultValue="+37x" /></div>
                    </div>
                    <div id="additional-fields"></div>
                </div>
                <div className="form-group form-field"><button type="button" className="btn btn-lg btn-default dark" id="cancel">Cancel</button>
                <button type="button" className="btn btn-lg btn-primary dark" id="add_booking" >Add more bookings</button>
                <button type="button" className="btn btn-lg btn-primary dark" id="confirm_batch" >Confirm</button>
                <button type="button" className="btn btn-lg btn-primary dark" id="confirm">Confirm</button></div>
            </div>

        </form>
        </div>
    </div>
    );
    }
}
 
export default TimePicker;
